import { Card } from "@mui/material";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import useDialog from "@/hooks/use-dialog";
import IContact from "@/interfaces/contact.interface";
import { ContactInfoMessages } from "@/messages/contacts/contact-Info.messages";

import { AdditionalAddressesTable } from "../AdditionalAddressesTable";
import AddressDialog from "../AdressDialog";

interface Props {
  contact: IContact;
  messages: ContactInfoMessages;
}

export function AdditionalAddresses({ contact, messages }: Props) {
  const { isVisible, handleOpen, handleClose } = useDialog();

  return (
    <Card>
      <MDBox p={3}>
        <MDBox
          p={2}
          pl={0}
          pr={0}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography variant="h5" fontWeight="bold">
            {messages.titleCardAddress}
          </MDTypography>

          <MDButton variant="outlined" color="dark" onClick={handleOpen}>
            {messages.createButton}
          </MDButton>
        </MDBox>

        <AdditionalAddressesTable contact={contact} messages={messages} />

        <AddressDialog
          isOpen={isVisible}
          onClose={handleClose}
          address={null}
          contact={contact}
          messages={messages}
          isEditing={false}
        />
      </MDBox>
    </Card>
  );
}
